import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { ProjectsCard } from "./../../ProjectsWrapperCard";

export const ProjectsTab = (setProjectsVisible, authenticatedResources) => {
  console.log(setProjectsVisible);
  return (
    <>
      <div className="flex-grow flex sm:hidden flex-col px-4 py-5 sm:p-6 overflow-y-scroll h-full">
        {/* Not full size view */}
        <div className="bg-blue-100 border border-blue-300 text-blue-800 rounded-lg px-4 py-2 mb-3 text-center font-medium">
          Visit on desktop for an interactive project viewer.
        </div>
        <h1 className="text-gray-700 text-2xl font-bold p-2">Projects</h1>
        <div className="sm:hidden">
          <h1 className="text-gray-700 text-xl font-bold p-2 pb-1">Whenfin</h1>
          <h2 className="text-gray-600 text-lg font-semibold p-2 pt-1 pb-2">
            My current project, Whenfin, is a platform that allows Python
            scripts to send notifications to iOS devices. It includes a{" "}
            <a
              href="https://pypi.org/project/whenfin/"
              target="_blank"
              className="text-blue-600"
            >
              Python module
            </a>{" "}
            which connects to an Express API, a mobile app, and a{" "}
            <a
              className="text-blue-600"
              href="https://whenfin.com"
              target="_blank"
            >
              webpage
            </a>
            . I've recently improved infrastructure uptime, so the app is
            available for testing on{" "}
            <a
              className="text-blue-600"
              href="https://apps.apple.com/us/app/whenfin/id6504001973"
              target="_blank"
            >
              the App Store
            </a>
            . Hoping to port to Android soon.
          </h2>
          <a href="https://whenfin.com" target="_blank">
            <div className="bg-gray-200 border border-gray-400 rounded-lg shadow-md p-4 inline-flex gap-3 items-center hover:cursor-pointer transition mb-5">
              <div className="relative">
                <div className="absolute bg-green-500 animate-ping h-3 w-3 rounded-full opacity-75" />
                <div className="bg-green-500 h-3 w-3 rounded-full" />
              </div>
              <span className="font-semibold text-gray-700 text-lg">
                Whenfin
              </span>
              <ArrowRightIcon className="h-6 w-6 text-gray-700" />
            </div>
          </a>
          <h1 className="text-gray-700 text-xl font-bold p-2 pb-1">Loopster</h1>
          <h2 className="text-gray-600 text-lg font-semibold p-2 pt-1 pb-2">
            Loopster was my pet project last summer; the open-source web
            application allows for users to process their Spotify playing
            history in order to retroactively make playlists that contain songs
            they have enjoyed listening to in series. The code is published on{" "}
            <a
              href="https://github.com/Luca-W-D/loopster"
              target="_blank"
              className="text-blue-600"
            >
              Github
            </a>{" "}
            & is hosted on Netlify.
          </h2>
          <a href="https://loopster.l-uca.com" target="_blank">
            <div className="bg-gray-200 border border-gray-400 rounded-lg shadow-md p-4 inline-flex gap-4 items-center hover:cursor-pointer transition mb-5">
              <div className="relative">
                <div className="absolute bg-green-500 animate-ping h-3 w-3 rounded-full opacity-75" />
                <div className="bg-green-500 h-3 w-3 rounded-full" />
              </div>
              <span className="font-semibold text-gray-700 text-lg">
                Loopster
              </span>
              <ArrowRightIcon className="h-6 w-6 text-gray-700" />
            </div>
          </a>
          <h1 className="text-gray-700 text-xl font-bold p-2 pb-1">
            Past projects
          </h1>
          <h2 className="text-gray-600 text-lg font-semibold p-2 pt-1 pb-4">
            I've worked on dozens of personal projects since starting high
            school, most of which have too many security vulnerabilities to host
            now...
          </h2>
          <h2 className="text-gray-600 text-lg font-semibold p-2 pt-1 pb-2">
            My largest published project is{" "}
            <a
              href="https://github.com/Luca-W-D/Blackbox/"
              target="_blank"
              className="text-blue-600"
            >
              Blackbox
            </a>
            , a combined full-stack website and botnet used to scrape market
            data from a game called Starscape. With permission from the game
            owner, the service collected & served gigabytes of market data live
            to paying customers.
          </h2>
          <div className="bg-gray-50 border border-gray-400 rounded-lg shadow-md p-4 inline-flex gap-4 items-center hover:cursor-not-allowed transition mb-5">
            <div className="relative">
              <div className="bg-red-500 h-3 w-3 rounded-full" />
            </div>
            <span className="font-semibold text-gray-400 text-lg">
              Blackbox
            </span>
          </div>
          <h2 className="text-gray-600 text-lg font-semibold p-2 pt-1 pb-4">
            Check out my{" "}
            <a
              href="https://github.com/Luca-W-D/"
              target="_blank"
              className="text-blue-600"
            >
              Github
            </a>
            , where I occassionally upload some prior archived projects
          </h2>
        </div>
        {/* Full size view */}
      </div>
      <ProjectsCard
        setProjectsVisible={setProjectsVisible}
        authenticatedResources={authenticatedResources}
      />
    </>
  );
};
